module.exports = __webpack_public_path__ + "assets/img/logo.e40abe6f.svg";